import type { BrandConfig } from '@estimating/branding';
import { isSupportedLocale, type Locale } from '@estimating/i18n';

const STORAGE_KEY = 'estimating.locale';

/** Where the user's language choice is remembered. */
export interface LocalePreferenceStore {
  read(): string | null;
  write(locale: Locale): void;
}

/** localStorage can throw (private windows, blocked site data); a lost preference is harmless. */
export function createLocalePreferenceStore(): LocalePreferenceStore {
  return {
    read() {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch {
        return null;
      }
    },
    write(locale) {
      try {
        window.localStorage.setItem(STORAGE_KEY, locale);
      } catch {
        // The choice just isn't remembered.
      }
    },
  };
}

/** The remembered choice if the brand offers it, otherwise the brand's default. */
export function resolveInitialLocale(brand: BrandConfig, remembered: string | null): Locale {
  return isSupportedLocale(remembered) && brand.supportedLocales.includes(remembered)
    ? remembered
    : brand.defaultLocale;
}
